import { useQuery } from '@tanstack/react-query'
import { apiPath, buildApiUrl } from '../_utils/api-version'
import { IBranch, IWorkHour } from '../_types'
import { request } from './http-client'
import { AxiosResponse } from 'axios'
import { TParams } from './types'

export const branchService = {
  getList: (
    params: TParams,
    useDynamicLanguage = false
  ): Promise<AxiosResponse<{ branches: IBranch[]; count: string }>> =>
    request.get(apiPath('branches', useDynamicLanguage), { params }),
  findNearest: (params: {
    long: number
    lat: number
    delivery_zone_id?: string
    order_type_id?: string
  }) =>
    request.get<{ branches: IBranch[] }>('/v1/nearest-branch', {
      params,
    }),
  findNearestByTime: (params: {
    long: number
    lat: number
    date_time: string
    order_type_id?: string
  }) =>
    request.get<{ branches: IBranch[] }>('/v1/branches/delivery-hours', {
      params,
    }),
  getBranchById: (
    id: string,
    useDynamicLanguage = false
  ): Promise<AxiosResponse<IBranch>> =>
    request.get(buildApiUrl('branches', useDynamicLanguage, id)),
  getWorkingHours: (params: TParams) =>
    request.get<{ working_hours: IWorkHour[] }>(`/v2/working-hours`, {
      params,
    }),
}

export const useBranchList = ({
  params,
  props = { enabled: false },
  useDynamicLanguage = false,
}: {
  params: any
  props: any
  useDynamicLanguage?: boolean
}) => {
  return useQuery<
    {
      count: string
      branches: IBranch[]
    },
    Error
  >({
    queryKey: ['branch_list', props, params, useDynamicLanguage],
    queryFn: () =>
      branchService.getList(params, useDynamicLanguage).then((res) => res?.data),
    ...props,
  })
}
